var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('transfer',{attrs:{"user":_vm.user,"api_prefix":_vm.api_prefix}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }